import type { ExamStatus as ExamStatusType } from "@memorang/types";
import type { IconType } from "./icon";

export type {
	CurrentView,
	Distribution,
	ExamStatus,
	MixedItemTag,
	TagsByType,
} from "@memorang/types";

/** @deprecated Use `ExamStatus` from `@memorang/types` */
export type SESSION_STATUS = ExamStatusType;

export type ScoreRange = {
	rangeArray: number[];
	range: string;
	color: string;
	icon: string;
};

export interface ButtonProps {
	cta: string;
	icon: IconType;
	onPress: () => void;
	variant?: "small" | "large";
}

export interface FeaturedChallenge {
	sectionTitle: string;
	id: number;
	title: string;
	description: string;
	numResponses: number;
	buttonProps?: ButtonProps;
	imageUri?: string;
	videoUri?: string;
}

export type AnalyticsHandler = (
	params: Record<string, string | number | undefined>,
	userProperty?: Record<string, string>,
) => void;

export type QuickActionsChipType = {
	label: string;
	type: string;
	icon?: string;
	selected?: boolean;
	tooltip: string;
	disabled?: boolean;
};
